import { render, staticRenderFns } from "./ProfileInfoBanner.vue?vue&type=template&id=b54dde92&scoped=true&lang=pug&"
import script from "./ProfileInfoBanner.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoBanner.vue?vue&type=style&index=0&id=b54dde92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54dde92",
  null
  
)

export default component.exports